export const DEFAULT_PROMPT =
  "Premium editorial product photo, rearrange the product into a beautiful pose, at a slight angle to the camera, clean white background, the product perfectly lit to highlight every detail and texture."

export const MARBLE_PROMPT =
  "Premium editorial product photo, at a slight angle to the camera, clean white background, the product perfectly lit to highlight every detail and texture. Adjust the products position and angle slightly for a more flattering camera view."

export const DEFAULT_PROMPT_ALT =
  "A model is wearing this product in a professional product shot. Only the body part wearing the product is in the frame. Smooth, well-groomed skin, white background. Focus on the product, centered in the middle of the frame, shown at its true real-life size."

export const MODEL_SELECT_PROMPT =
  "Model is wearing or using the product. Focus on the product, centered in the middle of the frame and shown at its true real-life size. Adjust her body position, head angle, and hand placement so the product is clearly visible and well-presented."

export const MARBLE_STONE_PROMPT =
  "Macro close-up of the product on the marble stone, Eye-level product shot, ultra-detailed focus, Warm golden hour glow. Adjust the products position and angle slightly for a more flattering camera view."

export const MIRROR_SKY_PROMPT =
  "Jewellery on a mirror reflecting a blue sky with white clouds, shot from above, natural sunlight."

export const UGC_SELFIE_PROMPT =
  "UGC selfie of a young woman holding the product up to the camera, cheeky smile, slightly messy phone-camera framing, natural light."

export const LANDING_MODEL_STYLE_URL =
  "https://r2.jewlai.com/Media/landing-tryon-model-v2.jpg"

export const LANDING_MARBLE_STYLE_URL =
  "https://r2.jewlai.com/Media/landing-marble-stone.jpg"
